// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/leftUnderMenu/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/sort-horizontal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/sort-vertical.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/sort-horizontal-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/sort-vertical-box.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.desktop_file_icon{
    width: 36px;
    height: 36px;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    position: relative;
}

.desktop_file_name{
    font-style: normal;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 18px;
    text-align: center;
    color: #000000;
    color: var(--fileNameColor);
    padding: 2px 4px;
    word-break: break-all;

    text-shadow: 0px 1px 5px var(--fileNameShadowColor), 0px 1px 2px var(--fileNameShadowColor), 0px 1px 1px var(--fileNameShadowColor);
}

.desktop_file_name_noRename{
    cursor: default;
}

.desktop_file_renameInput_wrap{
    position: relative;
    width: 100%;
}

.desktop_file_name_sizer {
    opacity: 0;
    pointer-events: none;
    white-space: pre-wrap;
    word-break: break-all;
    font-style: normal;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 18px;
    text-align: center;
    padding: 3px 6px;
    min-height: 18px;
}

.desktop_file_renameInput{
    display: block;
    border: 1px solid #0078d4;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 3px 6px;
    border-radius: 2px;
    
    /* Windows-like styling */
    background: #ffffff;
    box-shadow: 0 0 0 1px rgba(0, 120, 212, 0.4);
    
    /* Text styling to match the original */
    font-style: normal;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 18px;
    text-align: center;
    color: #000000;
    
    resize: none;
    overflow: hidden;
    word-break: break-all;
    
    /* Smooth transitions */
    transition: all 0.2s ease;
}

.desktop_file_renameInput:focus{
    outline: none;
    border: 1px solid #0078d4;
    box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.3);
    background: #ffffff;
}

.desktop_file__linkIcon{
    width: 10px;
    height: 10px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    right: -3px;
    bottom: -3px;
}

.desktop_file__linkIcon--g{
    width: 12px;
    height: 12px;
}

.desktop_file__linkIcon--analysis{
    width: 13px;
    height: 13px;
}

.desktop_file__fileIndicator{
    position: absolute;
    top: -2px;
    left: -2px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #ddd;
}

.desktop_file{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 80px;
    border: 1px dotted #ccc0;
    border-radius: 5px;
}

.desktop_file_tint{
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    display: flex;
    justify-content: center;
    background-color: #ccf3;
    border-radius: 5px;
    padding-top: 10px;
    opacity: 0;
}

.desktop_file_arrow{
    width: 16px;
    height: 16px;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.desktop_file_plus{
    width: 16px;
    height: 16px;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.desktop_file_selected{
    background-color: #F3F6FF44;
    border: 1px dotted #fff;
}

.desktop_file_underDrop{
    /*background-color: #006c1044;*/
    border: 1px dotted #fff;

    .desktop_file_tint{
        opacity: 1;
    }
}

.DesktopFileItem--lastSelected{
    border-color: #93B4EB !important;
}

/* Sorting buttons styling - matches breadcrumb style */
.DesktopFileView_sortButtons {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 4px;
}

.DesktopFileView_sortButton {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 48px;
    width: 48px;
    /* Beautiful background for visibility on any desktop image - matches breadcrumb style */
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(8px);
    border-radius: 8px;
    padding: 1px;
    margin: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    
    /* Smooth transitions for better UX */
    transition: all 0.2s ease;
    cursor: pointer;
}

.DesktopFileView_sortButton:hover {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
}

.DesktopFileView_sortIcon {
    width: 48px;
    height: 48px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.7;
}

.DesktopFileView_sortIcon--horizontal {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.DesktopFileView_sortIcon--vertical {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.DesktopFileView_sortIcon--horizontalBox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.DesktopFileView_sortIcon--verticalBox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/DesktopFileItem.css"],"names":[],"mappings":"AAAA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,yDAAoD;IACpD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;;IAE3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;;IAErB,mIAAmI;AACvI;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,kBAAkB;;IAElB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;;IAE5C,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;IAEd,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;;IAErB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,yDAAqD;IACrD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,yDAAkE;IAClE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;;IAEvB;QACI,UAAU;IACd;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA,uDAAuD;AACvD;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,wFAAwF;IACxF,qCAAqC;IACrC,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,0CAA0C;;IAE1C,qCAAqC;IACrC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,yDAA+D;AACnE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAmE;AACvE;;AAEA;IACI,yDAAiE;AACrE","sourcesContent":["@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.desktop_file_icon{\n    width: 36px;\n    height: 36px;\n\n    background-image: url(\"../../../../assets/star.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n\n    position: relative;\n}\n\n.desktop_file_name{\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 18px;\n    text-align: center;\n    color: #000000;\n    color: var(--fileNameColor);\n    padding: 2px 4px;\n    word-break: break-all;\n\n    text-shadow: 0px 1px 5px var(--fileNameShadowColor), 0px 1px 2px var(--fileNameShadowColor), 0px 1px 1px var(--fileNameShadowColor);\n}\n\n.desktop_file_name_noRename{\n    cursor: default;\n}\n\n.desktop_file_renameInput_wrap{\n    position: relative;\n    width: 100%;\n}\n\n.desktop_file_name_sizer {\n    opacity: 0;\n    pointer-events: none;\n    white-space: pre-wrap;\n    word-break: break-all;\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 18px;\n    text-align: center;\n    padding: 3px 6px;\n    min-height: 18px;\n}\n\n.desktop_file_renameInput{\n    display: block;\n    border: 1px solid #0078d4;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 3px 6px;\n    border-radius: 2px;\n    \n    /* Windows-like styling */\n    background: #ffffff;\n    box-shadow: 0 0 0 1px rgba(0, 120, 212, 0.4);\n    \n    /* Text styling to match the original */\n    font-style: normal;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 18px;\n    text-align: center;\n    color: #000000;\n    \n    resize: none;\n    overflow: hidden;\n    word-break: break-all;\n    \n    /* Smooth transitions */\n    transition: all 0.2s ease;\n}\n\n.desktop_file_renameInput:focus{\n    outline: none;\n    border: 1px solid #0078d4;\n    box-shadow: 0 0 0 2px rgba(0, 120, 212, 0.3);\n    background: #ffffff;\n}\n\n.desktop_file__linkIcon{\n    width: 10px;\n    height: 10px;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    position: absolute;\n    right: -3px;\n    bottom: -3px;\n}\n\n.desktop_file__linkIcon--g{\n    width: 12px;\n    height: 12px;\n}\n\n.desktop_file__linkIcon--analysis{\n    width: 13px;\n    height: 13px;\n}\n\n.desktop_file__fileIndicator{\n    position: absolute;\n    top: -2px;\n    left: -2px;\n    font-size: 12px;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 3px;\n    width: 16px;\n    height: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #ddd;\n}\n\n.desktop_file{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 80px;\n    border: 1px dotted #ccc0;\n    border-radius: 5px;\n}\n\n.desktop_file_tint{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    display: flex;\n    justify-content: center;\n    background-color: #ccf3;\n    border-radius: 5px;\n    padding-top: 10px;\n    opacity: 0;\n}\n\n.desktop_file_arrow{\n    width: 16px;\n    height: 16px;\n\n    background-image: url(\"../../../../assets/arrow.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.desktop_file_plus{\n    width: 16px;\n    height: 16px;\n\n    background-image: url(\"../../../../assets/leftUnderMenu/plus.svg\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.desktop_file_selected{\n    background-color: #F3F6FF44;\n    border: 1px dotted #fff;\n}\n\n.desktop_file_underDrop{\n    /*background-color: #006c1044;*/\n    border: 1px dotted #fff;\n\n    .desktop_file_tint{\n        opacity: 1;\n    }\n}\n\n.DesktopFileItem--lastSelected{\n    border-color: #93B4EB !important;\n}\n\n/* Sorting buttons styling - matches breadcrumb style */\n.DesktopFileView_sortButtons {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n.DesktopFileView_sortButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 40px;\n    height: 48px;\n    width: 48px;\n    /* Beautiful background for visibility on any desktop image - matches breadcrumb style */\n    background: rgba(255, 255, 255, 0.92);\n    backdrop-filter: blur(8px);\n    border-radius: 8px;\n    padding: 1px;\n    margin: 2px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    \n    /* Smooth transitions for better UX */\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.DesktopFileView_sortButton:hover {\n    background: rgba(255, 255, 255, 0.98);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    transform: translateY(-1px);\n}\n\n.DesktopFileView_sortIcon {\n    width: 48px;\n    height: 48px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    opacity: 0.7;\n}\n\n.DesktopFileView_sortIcon--horizontal {\n    background-image: url(\"../../../../assets/sort-horizontal.png\");\n}\n\n.DesktopFileView_sortIcon--vertical {\n    background-image: url(\"../../../../assets/sort-vertical.png\");\n}\n\n.DesktopFileView_sortIcon--horizontalBox {\n    background-image: url(\"../../../../assets/sort-horizontal-box.png\");\n}\n\n.DesktopFileView_sortIcon--verticalBox {\n    background-image: url(\"../../../../assets/sort-vertical-box.png\");\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
